import React from 'react';
import { Linkedin, ArrowUp } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const services = [
    { name: t('services.service1.title'), slug: 'ai-tabanli-secme-yerlestirme' },
    { name: t('services.service2.title'), slug: 'ik-sistem-kurulum' },
    { name: t('services.service3.title'), slug: 'proje-bazli-danismanlik' },
    { name: t('services.service4.title'), slug: 'dijital-ik-egitimi' },
    { name: t('services.service5.title'), slug: 'kurumsal-yazilim-cozumleri' }
  ];

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8 relative overflow-hidden">
      {/* Background Decorations */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-yellow-500/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-yellow-400/10 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brand Section */}
          <div>
            <div className="mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_hippopartners/artifacts/dky1nvsa_Resim1.png" 
                alt="Hippo Partners Logo" 
                className="h-14 w-auto object-contain"
              />
            </div>
            <p className="text-gray-400 leading-relaxed mb-6">
              {t('footer.description')}
            </p>
            <a
              href="https://www.linkedin.com/company/partnershippo"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center w-12 h-12 bg-yellow-400 rounded-full hover:scale-110 transition-transform duration-300 shadow-lg"
            >
              <Linkedin className="h-6 w-6 text-gray-900" />
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xl font-bold mb-6">{t('footer.quickLinks')}</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-yellow-400 transition-colors"
                >
                  {t('nav.about')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-yellow-400 transition-colors"
                >
                  {t('nav.services')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('approach')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-yellow-400 transition-colors"
                >
                  {t('nav.approach')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-yellow-400 transition-colors"
                >
                  {t('nav.contact')}
                </button>
              </li>
            </ul>
          </div>

          {/* Services Summary - Updated to 3 services */}
          <div>
            <h4 className="text-xl font-bold mb-6">{t('footer.serviceAreas')}</h4>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index}>
                  <Link
                    to={`/hizmet/${service.slug}`}
                    className="text-gray-400 hover:text-yellow-400 transition-colors text-sm"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm mb-4 md:mb-0">
            {t('footer.copyright')}
          </p>
          <div className="flex space-x-6">
            <a href="#" className="text-gray-500 hover:text-yellow-400 text-sm transition-colors">
              {t('footer.privacy')}
            </a>
            <a href="#" className="text-gray-500 hover:text-yellow-400 text-sm transition-colors">
              {t('footer.terms')}
            </a>
          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <button
        onClick={scrollToTop}
        className="fixed bottom-8 right-8 w-14 h-14 bg-yellow-400 rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-transform duration-300 z-50"
        aria-label="Scroll to top"
      >
        <ArrowUp className="h-6 w-6 text-gray-900" />
      </button>
    </footer>
  );
};

export default Footer;